module.exports = __webpack_public_path__ + "static/img/bg.6fa62099.png";